import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import type {
  FilterKey,
  SlugParamKey,
  SlugParamMappingType,
} from '@core/Entities/Search/QueryParams.entity';

export const PLP_ROOTS: PlpRoot[] = ['lease-deals', 'new', 'used'];

export const NUM_RESULTS_PP = 18;

export const MAX_NON_MMV_SLUG_PARAMS: Record<PlpRoot, number> = {
  used: 2,
  new: 0,
  'lease-deals': 1,
};

export const SEO_PAGE_MIN_RESULTS = 4;

export const MAX_DISTANCE_DEFAULT = '60';

export const MAX_DISTANCE_LOCATION = '40';

export const SLUG_PARAM_KEYS: SlugParamKey[] = [
  'area',
  'make',
  'model',
  'variant',
  'body-type',
  'fuel-type',
  'price',
  'gear-box',
  'color',
  'doors',
  'seats',
  'badge_engine_cc',
  'page',
];

export const ALWAYS_INDEXABLE_KEYS: FilterKey[] = ['area', 'make', 'model', 'variant-type', 'page'];

export const slugParamMapping: SlugParamMappingType = {
  area: _ => ['area'],
  make: _ => ['make'],
  model: _ => ['model'],
  variant: _ => ['variant-type'],
  'body-type': _ => ['body-type'],
  'fuel-type': _ => ['fuel-type'],
  price: root => (root === 'lease-deals' ? ['monthly-price__lte'] : ['price__lte']),
  'gear-box': _ => ['gear-box'],
  color: _ => ['color'],
  doors: _ => ['doors'],
  seats: _ => ['seats'],
  badge_engine_cc: _ => ['engine-size__gte', 'engine-size__lte'],
  page: _ => ['page'],
};
